// src/pages/IrsConfirmation.js
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { fmtDateTimeUS } from '../utils/dates';
import HeaderLogged from '../components/HeaderLogged';
import Footer from '../components/Footer';
import { useWizardFormId } from '../utils/wizardForm';

function AmendedIrsConfirmation() {
  const navigate = useNavigate();
  // Номер формы — из адреса этой вкладки (см. utils/wizardForm.js)
  const formId = useWizardFormId();
  const hasRun = useRef(false);
  const [irsSubmissionId, setIrsSubmissionId] = useState('');
  const [submissionDate, setSubmissionDate] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [alreadySubmitted, setAlreadySubmitted] = useState(false);

  const steps = [
    { id: 1, label: 'Tax & Form' },
    { id: 2, label: 'Vehicles Tax' },
    { id: 3, label: 'IRS Payment Options' },
    { id: 4, label: 'Form Summary' },
    { id: 5, label: 'Payment & Submission' },
    { id: 6, label: 'IRS Confirmation' },
  ];
  const currentStep = 6;

  useEffect(() => {
    if (!formId) return; // useWizardFormId уводит на страницу компании
    if (hasRun.current) return;
    hasRun.current = true;

    const checkFormStatus = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setError('No auth token');
        return;
      }

      try {
        // 1) GET текущий статус формы
        const formRes = await fetch(`/api/form2290/${formId}/`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!formRes.ok) {
          throw new Error('Failed to load form status');
        }
        const formData = await formRes.json();
        let hasError = true;
        try {
          const subRes = await fetch(`/api/forms/${formId}/irs-submissions/latest/`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (subRes.ok) {
            const subData = await subRes.json();
            hasError = subData.has_error;
          }
        } catch {
        }
        if (
          formData.status === 'send' ||
          formData.status === 'complete' ||
          (formData.status === 'incomplete' && hasError === false)
        ) {
          setAlreadySubmitted(true);

          const saved = localStorage.getItem('currentIrsSubmissionId');
          if (saved) {
            setIrsSubmissionId(saved);
          }
          setSubmissionDate(fmtDateTimeUS(new Date()));
        } else {
          setAlreadySubmitted(false);
          setError(
            'There was an error submitting your form. ' +
            'Please contact support@2290pay.org for assistance. We will respond within 24–48 hours.'
          );
        }
      } catch (e) {
        setError('Unable to fetch form status');
      }
    };

    checkFormStatus();
  }, [formId]);

  return (
    <div className="flex flex-col min-h-screen bg-[#E4F2FF]">
      <HeaderLogged />

      <main className="flex-1 py-6 px-4 flex justify-center">
        <div className="w-full max-w-4xl bg-white border border-gray-200 shadow-md p-6">
          <h1 className="text-2xl font-semibold text-[#0F2C5E] mb-4">
            IRS Confirmation
          </h1>

          {error && (
            <p className="text-red-600 mb-4">{error}</p>
          )}

          {submitting && (
            <p className="text-gray-600 mb-4">Submitting to IRS…</p>
          )}

          {alreadySubmitted && !submitting && (
            <>
              <p className="text-gray-700 mb-2">
                Form was submitted to the IRS.
              </p>
              {irsSubmissionId && (
                <p className="text-gray-700 mb-2">
                  <span className="font-medium">IRS Submission ID:</span>{' '}
                  {irsSubmissionId}
                </p>
              )}
              {submissionDate && (
                <p className="text-gray-700 mb-4">
                  <span className="font-medium">Submission Date:</span>{' '}
                  {submissionDate}
                </p>
              )}
              <p className="text-gray-700 mb-6">
                You will receive an email confirmation shortly. If you need to
                review your submission, you can access it from your dashboard.
              </p>
            </>
          )}

          <div className="flex justify-end mt-6">
            <button
              onClick={() => navigate('/dashboard')}
              className="bg-[#0F2C5E] text-white px-6 py-2 hover:bg-[#0F2C5E]/80 transition text-sm"
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default AmendedIrsConfirmation;
